import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import closeImg from '../../../images/icons/close.png';

import { setCheckedVersion } from '../../../actions/member';

import {
  FONT_MODE, NEW_VERSION,
} from '../../../constants/constants';

import config from '../../../constants/config';

const isInAppFrame = config.isInAppFrame();

class NewVersion extends React.Component {
  static propTypes = {
    newVersion: PropTypes.number,
    t: PropTypes.func.isRequired,
    setCheckedVersionFunc: PropTypes.func.isRequired,
    fontMode: PropTypes.string,
    openChangeLogVersionModal: PropTypes.bool,
    closeTriggerChangeLogModal: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
  }

  static defaultProps = {
    newVersion: null,
    fontMode: FONT_MODE.normal,
    openChangeLogVersionModal: false,
    hidden: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      version: NEW_VERSION || '3.10.1',
    };
  }

  closeModal = () => {
    const { closeTriggerChangeLogModal, setCheckedVersionFunc } = this.props;
    const { version } = this.state;
    closeTriggerChangeLogModal();
    setCheckedVersionFunc(version);
  }

  render() {
    const { newVersion, t, i18n, fontMode, setCheckedVersionFunc, openChangeLogVersionModal, hidden } = this.props;
    const { version } = this.state;

    console.log('newVersion modal', openChangeLogVersionModal, newVersion, version);

    if (hidden) {
      return null;
    }

    if ((!newVersion || newVersion >= version) && !openChangeLogVersionModal) {
      if (!newVersion) {
        console.log('setCheckedVersionFunc');
        setCheckedVersionFunc(version);
      }
      return null;
    }

    return (
      <Modal container={'div > div'} isOpen size="lg" className={`${isInAppFrame ? 'modal-is-app-frame' : ''} notification new-version-modal old-modal root-font-${fontMode}`}>
        <ModalHeader
          toggle={this.closeModal}
          className="notification-header"
          close={
            <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.closeModal} />
            }
        />
        <ModalBody className="notification-body">
          <div className="new-version-modal-scrollarea">
            {(!i18n.language || i18n.language === 'lv') ? (
              <>
                <h2 className="new-version-header">Sveiki, zolmaņi!</h2>
                <p className="new-version-body">Pēdējā laikā esam strādājuši pie kārtējā spēles atjauninājuma, kurā ir iekļauti šādi jaunumi un labojumi:</p>
                <ul className="new-version-body">
                  <li> Novērstas problēmas ar kāršu attēlošanu galda skatā, kā arī situācijas, kad izspēlētās kārtis netika novāktas no galda.</li>
                  <li> Izlaboti kļūdaini attēli vairākiem sasniegumiem.</li>
                  <li> Uzlabota puļu attēlošana istabas informācijas skatā, kā arī spēļu ierakstos.</li>
                  <li> Izlabota problēma, kad ceļveža bonuss netika piešķirts, spēlējot no mobilā pārlūka.</li>
                  <li> Novērsta problēma, kad pēc konkrētām darbībām istabai varēja pievienoties arī ignorēts spēlētājs.</li>
                  <li> Izlabota kļūda, kad galda skatā, atverot spēlētāja informācijas logu, tika attēloti cita spēlētāja dati.</li>
                  <li> Novērsta problēma, kad Facebook platformā nevarēja iegādāties reklāmu noņemšanu.</li>
                  <li> Novērsta problēma, kad nevarēja pievienoties istabai, jo parādījās uzraksts par dalību citā istabā.</li>
                  <li> Turpmāk informācija pa ieplānotajiem turnīriem būs pieejama jau vairākas dienas iepriekš.</li>
                  <li> Tiks rīkoti arī turnīri, kuriem varēs pieteikties tikai konkrētiem kritērijiem atbilstoši spēlētāji - pēc līmeņa, punktu skaita, bilances, izspēlētām partijām.</li>
                  <li> Istabas skatā dāvanu iegādes logā dāvanas tagad ir grupētas pēc kategorijām, lai atvieglotu to izvēli.</li>
                  <li> Veikalā tagad ir iespējams iegādāties VIP paku, kas sniedz dažādas papildu iespējas, piemēram:
                    <ul>
                      <li> Laimes ratā ir lielākas un tikai pozitīvas balvas</li>
                      <li> var izveidot istabas ar jebkādu likmi, kā arī izveidotā istaba viemēr būs istabu saraksta augšgalā</li>
                      <li> var paslēpt emocijzīmes un dāvanas spēles istabā</li>
                      <li> var labot profilu bez ierobežojumiem</li>
                      <li> var ieslēgt auto izspēli uz vairāk kā vienu partiju</li>
                      <li> netiek rādītas reklāmas</li>
                    </ul>
                  </li>
                  <li> Ir iespēja spēlēt jaunu Zoles veidu: Studentu zole - istaba ar diviem spēlētājiem</li>
                  <li> Dažādi citi uzlabojumi.</li>
                </ul>

                <p className="new-version-body">Tālākā spēles izstrādē esam ieplānojuši ieviest šādus (un ne tikai!) papildinājumus:</p>
                <ul className="new-version-body">
                  <li> Iespēju mainīt autorizācijas metodi starp sociālo tīklu pasēm un e-pastu/paroli.</li>
                  <li> Pievienot istabas veidu bez laika ierobežojuma gājiena veikšanai.</li>
                  <li> Atjaunināt un papildināt spēles palīdzības saturu.</li>
                  <li> Rīkot turnīrus par maksu ar reālām balvām.</li>
                </ul>
                <p className="new-version-body">Jūsu Zoles administrācija</p>
              </>
            ) : (null)}


            {(i18n.language === 'en') ? (
              <>
                <h2 className="new-version-header">Hello players!</h2>

                <p className="new-version-body">We've recently been working on a regular update to the game that includes the following news and fixes:</p>
                <ul className="new-version-body">
                  <li> Resolved issues with card display in the game room, including cases where played cards sometimes weren’t removed from the table.</li>
                  <li> Replaced incorrect images for several achievements.</li>
                  <li> Improved Pules display in the Room Results and Game logs.</li>
                  <li> Fixed a bug where the Game Guide bonus wasn’t awarded when playing via a mobile browser.</li>
                  <li> Addressed an issue where a player you blocked could occasionally rejoin the room after certain actions.</li>
                  <li> Fixed a bug where opening a player’s info window in the game room displayed another player’s data.</li>
                  <li> Resolved an issue where disabling ads couldn’t be purchased on Facebook app. </li>
                  <li> Fixed an error preventing players from joining a room due to a false "Room already created" message.</li>
                  <li> Future tournament announcements will now be posted several days in advance.</li>
                  <li> New exclusive tournaments will be introduced, limited to players meeting specific criteria (level, points, balance, or games played).</li>
                  <li> Gifts in the purchase window are now grouped by category for easier selection.</li>
                  <li> A new VIP package is available in the shop, offering:
                    <ul>
                      <li> Larger, exclusively positive rewards in the Lucky Wheel.</li>
                      <li> Ability to create rooms with any bet amount, with created rooms pinned to the top of the list.</li>
                      <li> Option to hide emojis and gifts in the game room.</li>
                      <li> Unlimited profile editing.</li>
                      <li> Enable multi-game autoplay.</li>
                      <li> Ad-free experience.</li>
                    </ul>
                  </li>
                  <li> Added "Student Zole" - a new two-player room variant.</li>
                  <li> Minor optimizations and fixes.</li>
                </ul>

                <p className="new-version-body">Planned Future Features:</p>
                <ul className="new-version-body">
                  <li> Allow switching login methods (between social media and email/password).</li>
                  <li> Introduce a new room type with no turn time limit.</li>
                  <li> Update and expand the Game Help section.</li>
                  <li> Host paid tournaments with real-world prizes.</li>
                </ul>
                <p className="new-version-body">Your Zole Administration</p>

              </>
            ) : (null)}



            {(i18n.language === 'ru') ? (
              <>
                <h2 className="new-version-header">Здравствуйте, уважаемый игрок!</h2>

                <p className="new-version-body">Недавно мы закончили работу над очередным обновлением игры, которое включает в себя следующие улучшения и исправления:</p>
                <ul className="new-version-body">
                  <li> Решены проблемы с отображением карт в игровой комнате, а также ситуации, когда сыгранные карты иногда не убирались со стола.</li>
                  <li> Заменены изображения, содержащие ошибки, для нескольких достижений.</li>
                  <li> Улучшено отображение пуль в итоговой информации о комнате, а также в записях игр.</li>
                  <li> Исправлена ошибка, когда бонус за прохождение Игрового пособия не начислялся при игре с мобильного браузера.</li>
                  <li> Устранена проблема, когда после определенных действий к комнате мог присоединиться вами заблокированный игрок.</li>
                  <li> Исправлена ошибка, когда в игровой комнате при открытии окна информации об игроке отображались данные другого игрока.</li>
                  <li> Устранена проблема, когда на платформе Facebook нельзя было приобрести отключение рекламы. </li>
                  <li> Устранена проблема, когда нельзя было присоединиться к комнате, так как появлялось сообщение об уже созданной комнате.</li>
                  <li> В дальнейшем информация о запланированных турнирах будет доступна за несколько дней заранее.</li>
                  <li> Также будут проводиться турниры, в которых смогут участвовать только игроки, соответствующие определенным критериям: по уровню, количеству очков, балансу и сыгранным партиям.</li>
                  <li> В окне покупки подарков они теперь сгруппированы по категориям, чтобы облегчить их выбор.</li>
                  <li> В магазине теперь можно приобрести VIP-пакет, который предоставляет различные дополнительные возможности:
                    <ul>
                      <li> в Колесе удачи — более крупные и только позитивные выигрыши</li>
                      <li> можно создавать комнаты с любой ставкой, а созданная комната всегда будет вверху списка комнат</li>
                      <li> можно скрыть смайлики и подарки в игровой комнате</li>
                      <li> можно редактировать профиль без ограничений</li>
                      <li> можно включить автоматическую игру больше чем на одну партию</li>
                      <li> не показывается реклама</li>
                    </ul>
                  </li>
                  <li> Добавлена возможность играть в новый вид Золы — "Студенческая зола" — комната для двух игроков.</li>
                  <li> Другие усовершенствования.</li>
                </ul>

                <p className="new-version-body">В дальнейшем мы планируем внедрить следующие (и не только эти!) дополнения:</p>
                <ul className="new-version-body">
                  <li> Возможность менять метод авторизации между социальными сетями и эл. почтой/паролем.</li>
                  <li> Добавить новый тип комнаты без ограничения времени на ход.</li>
                  <li> Обновить и дополнить Справку игры.</li>
                  <li> Проводить платные турниры с реальными призами.</li>
                </ul>
                <p className="new-version-body">Ваша администрация</p>
              </>
            ) : (null)}
          </div>
        </ModalBody>
        <ModalFooter className="notification-footer">
          <Button color="link" className="notification-footer-button" onClick={this.closeModal}>{t('common.ok')}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  newVersion: state.member.newVersion || null,
});

const mapDispatchToProps = {
  setCheckedVersionFunc: setCheckedVersion,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(NewVersion));
